import {MuWidget} from "mu-widget/lib/MuWidget";
import {Utils} from "./Utils";

export class CronRuleItems extends MuWidget{
}

export class CronRule extends MuWidget
{
	private activeItem: any;
	// @ts-ignore
	public url: Record<string, string>;

	beforeIndex() {
		this.muAppendContent(`
		<ul mu-id="items">
			<li mu-template="item" mu-widget="CronRuleItem">
				<div><span mu-id="title" class="a">Nenastaveno</span> <span title="Zobrazit/skrýt datumy" mu-id="btToglePreview" class="icon-calendar a"></span></div>
				<ul mu-id="errors" class="error-list">
				</ul>
				<ul mu-id="preview" class="" style="display: none">
				</ul>
			</li>
		</ul>
		<span class="-btn-default -btn a" mu-id="btAddItem"><span class="icon-plus"></span> Přidat</span>
		<div mu-id="editor" class="panel panel-default">
			<div class="panel-heading">
				<select mu-id="type">` +
			Utils.htmlOptions({
				"": "Vyberte",
				year: "Ročně",
				month: "Měsíčně",
				week: "Týdně",
				day: "Denně",
			}) +
			`
				</select>
				<span class="pull-right">
					<span class="a icon-yes" mu-id="btSave" title="Zapsat"></span>
					<span class="a icon-no" mu-id="btCloseEditor" title="Zavřít"></span>
					<span class="a icon-trash" mu-id="btDelete" title="Smazat"></span>
				</span>
			</div>
			<div class="panel-body">
				<div mu-id="block_year">
					<label>
						Každý 
						<input type="number" mu-id="year_yearPeriod" size="3" maxlength="3" />
						rok 
					</label>
					<label>
						Modulo
						<input type="number" mu-id="year_yearMod" size="3" maxlength="3" />
					</label><br />
					<label>
						Měsíc: <select mu-id="year_dayOfYearMonth">` +
			Utils.htmlOptions({
				1: "leden",
				2: "únor",
				3: "březen",
				4: "duben",
				5: "květen",
				6: "červen",
				7: "červenec",
				8: "srpen",
				9: "září",
				10: "říjen",
				11: "listopad",
				12: "prosinec",
			}) +
			`</select>
					</label>
					<label>
						Den:
						<input type="number" mu-id="year_dayOfYearDay" />
					</label>
				</div>
				<div mu-id="block_month">
					<label>
						Den:
						<input type="number" mu-id="month_dayOfMoon" />
					</label>
				</div>
				<div mu-id="block_week">
					<label>
						Den:
						<select mu-id="week_dayOfWeek">` +
			Utils.htmlOptions({
				1: "Pondělí",
				2: "Úterý",
				3: "Středa",
				4: "Čtvrtek",
				5: "Pátek",
				6: "Sobota",
				0: "Neděle",
			}) +
			`</select>
					</label>
				</div>
				<div mu-id="block_day">
					<label>
						Každý 
						<input type="number" mu-id="day_dayPeriod" size="3" maxlength="3" />
						den 
					</label>
					<label>
						Modulo
						<input type="number" mu-id="day_dayMod" size="3" maxlength="3" />
					</label><br />
				</div>
			</div>
		</div>
		`);
	}

	afterIndex()
	{
		this.switchBlock();
		const values = JSON.parse(this.ui.input.value);
		if (values)
		{
			for(const val of values)
			{
				this.addItem(val);
			}
		}
		this.btCloseEditor_click();
	}
	type_change() {
		this.switchBlock();
	}
	switchBlock() {
		const curr = this.ui.type.value;
		for(const k of ["year", "month", "week", "day"])
		{
			this.muVisible(curr == k, "block_" + k);
		}
	}

	btAddItem_click() {
		this.addItem();
	}

	addItem(params: any = {}) {
		this.openEditor(this.muWidgetFromTemplate("item", "items", { value: params == undefined ? {} : params }));
	}

	openEditor(item: any)
	{
		this.muVisible(true, this.ui.editor);
		this.muVisible(false, this.ui.btAddItem);
		for(const k in this.ui)
		{
			const p = k.indexOf("_");
			if (p > -1)
			{
				var k2 = k.substr(p + 1);
				/* if (item.value[k2]) */
				this.ui[k].value = item.value[k2] ? item.value[k2] : "";
			}
		}
		this.activeItem = item;
		let t = "";
		if (item.value.dayOfMoon) t = "month";
		else if (item.value.dayOfWeek != undefined) t = "week";
		else if (item.value.dayPeriod != undefined) t = "day";
		else if (item.value.yearPeriod != undefined || item.value.yearMod != undefined || item.value.dayOfYearMonth != undefined || item.value.dayOfYearDay != undefined) t = "year";
		this.ui.type.value = t;
		this.switchBlock();
		this.selectItem(item);
	}

	selectItem(item: any|undefined = undefined)
	{
		MuWidget.getChildWidgets(this.ui.items).map((listItem: CronRuleItem) => listItem.setSelected(listItem == item));
	}

	btCloseEditor_click()
	{
		this.muVisible(false, "editor");
		this.muVisible(true, "btAddItem");
		this.selectItem();
	}

	saveEditor()
	{
		var t = this.ui.type.value;
		var value = {};
		for(var k in this.ui)
		{
			var p = k.indexOf("_");
			if (p > -1)
			{
				var k1 = k.substr(0, p);
				var k2 = k.substr(p + 1);
				if (t == k1) value[k2] = this.ui[k].value;
			}
		}
		this.activeItem.setValue(value);
		this.saveField();
	}

	btSave_click()
	{
		this.saveEditor();
		this.btCloseEditor_click()
	}

	saveField()
	{
		this.ui.input.value = JSON.stringify(MuWidget.getChildWidgets(this.ui.items).map(
			item => item.value
		));
	}

	btDelete_click()
	{
		if (confirm("Opravdu chcete smazat toto pravidlo?"))
		{
			this.ui.items.removeChild(this.activeItem.container);
			this.saveField();
			this.btCloseEditor_click();
		}
	}

	getUrl(cmd: string, params: Record<string, string>)
	{
		var url = this.url[cmd];

		url = url.replace(/__([a-zA-Z0-9]+)__/g, (m, n) => params[n] ? params[n] : "");
		return url;
	}
}

export class CronRuleItem extends MuWidget {
	private visiblePreview: boolean = false;
	protected value: any;
	// @ts-ignore
	muParent: CronRule;

	afterIndex()
	{
		this.setValue(this.value);
		this.visiblePreview = false;
	}

	async setValue(value: any)
	{
		this.value = value;
		this.ui.title.innerText = JSON.stringify(value);
		const data = await (await fetch(
			this.getUrl("preview", { src: JSON.stringify(this.value) })
		)).json();

		this.ui.title.innerText = data.name;
		this.ui.errors.innerHTML = Utils.htmlListText(data.errors);
		this.muVisible(data.errors.length > 0, this.ui.errors);
		this.ui.preview.innerHTML = Utils.htmlListText(data.preview);
		this.muVisible(data.preview.length > 0, "btToglePreview");
	}

	btToglePreview_click()
	{
		this.visiblePreview = !this.visiblePreview;
		this.muVisible(this.visiblePreview, this.ui.preview);
	}

	title_click()
	{
		this.muParent.openEditor(this);
	}

	setSelected(selected: boolean)
	{
		this.container.classList.toggle("selected", selected);
	}

	// @ts-ignore
	muParent: CronRule;
	getUrl(cmd: string, params: Record<string, string>) { return this.muParent.getUrl(cmd, params); }
}